import {IComplateRequest} from '../../../interfaces'
import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import moment from 'jalali-moment'

const contract_endpoints = APIS_ENDPOINTS.contract

export const request_imscompleterequest = async ({
  data,
  id,
}: {
  data: IComplateRequest
  id: number
}) => {
  const payload = {
    requestId: id,
    dateOfMeeting: moment(data.contractConclusionDate).format('YYYY-MM-DDTHH:mm:ss.SSSSSSS').includes("Invalid") ? "" : moment(data.contractConclusionDate).format('YYYY-MM-DDTHH:mm:ss.SSSSSSS'),
    isGratuitously: data.isGratuitously,
    contractNumber: data.contractNumber || '',
    contractAmount: data.contractAmount ? Number(data.contractAmount) : 0,
    facilityRate: data.facilityRate ?? 0,
    facilitiesBenefitAmount: data.facilitiesBenefitAmount
      ? Number(data.facilitiesBenefitAmount)
      : 0,
    planName: data.planName || '',
    planProvince: data.planProvince ?? null,
    planDomain: data.planDomain ?? null,
    partnershipStatus: data.partnershipStatus ?? null,
    serviceType: data.serviceType ?? null,
    serviceTypeDescription: data.serviceTypeDescription || '',
    facilityContractType: data.facilityContractType ?? null,
    facilityContractTypeDescription: data.facilityContractTypeDescription || '',
    paymentPeriod: data.paymentPeriod ?? null,
    paymentSteps: data.paymentSteps ?? null,
    breathingPeriod: data.breathingPeriod ?? null,
    repaymentPeriod: data.repaymentPeriod ?? null,
    repaymentSteps: data.repaymentSteps ?? null,
    installmentsInterval: data.installmentsInterval ?? null,
    loanDepositAmount: data.loanDepositAmount ? Number(data.loanDepositAmount) : null,
    haveSecurity: data.haveSecurity,
  }

  return http.post(contract_endpoints.upsertcontractrequest, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const request_getcontractresource = async ({RequestId}: {RequestId: Number}) => {
  return http.get(contract_endpoints.getcontractresource + '?RequestId=' + RequestId)
}

export const request_addcontractresource = async ({
  requestId,
  resourceType,
  rialWorth,
}: {
  requestId: number
  resourceType: string
  rialWorth: number
}) => {
  return http.post(contract_endpoints.addcontractresource, {
    requestId,
    resourceType,
    rialWorth,
  })
}

export const request_editcontractresource = async ({
  id,
  requestId,
  resourceType,
  rialWorth,
}: {
  id: number
  requestId: number
  resourceType: string
  rialWorth: number
}) => {
  return http.put(contract_endpoints.editcontractresource, {
    id,
    requestId,
    resourceType,
    rialWorth,
  })
}

export const request_deletecontractresource = async ({Id}: {Id: Number}) => {
  return http.delete(contract_endpoints.deletecontractresource + '?Id=' + Id)
}

export const request_getcontractapplicant = async ({RequestId}: {RequestId: Number}) => {
  return http.get(contract_endpoints.getcontractapplicant + '?RequestId=' + RequestId)
}

export const request_getcontractsecurity = async ({RequestId}: {RequestId: Number}) => {
  return http.get(contract_endpoints.getcontractsecurity + '?RequestId=' + RequestId)
}

export const request_addcontractsecurity = async ({
  requestId,
  securityCost,
  securityType,
  serialNumber,
  uploadFile,
}: {
  requestId: number
  securityType: number
  securityCost: number
  serialNumber: number
  uploadFile: number
}) => {
  return http.post(contract_endpoints.addcontractsecurity, {
    requestId,
    securityCost,
    securityType,
    serialNumber,
    uploadFile,
  })
}

export const request_editcontractsecurity = async ({
  id,
  requestId,
  securityCost,
  securityType,
  serialNumber,
  uploadFile,
}: {
  id: number
  requestId: number
  securityType: number
  securityCost: number
  serialNumber: number
  uploadFile: number
}) => {
  return http.put(contract_endpoints.editcontractsecurity, {
    id,
    requestId,
    securityCost,
    securityType,
    serialNumber,
    uploadFile,
  })
}

export const request_deletecontractsecurity = async ({Id}: {Id: Number}) => {
  return http.delete(contract_endpoints.deletecontractsecurity + '?Id=' + Id)
}

export const request_getcontractdeposit = async ({RequestId}: {RequestId: Number}) => {
  return http.get(contract_endpoints.getcontractdeposit + '?RequestId=' + RequestId)
}

export const request_addcontractdeposit = async ({
  requestId,
  amountConvertedIntoFree,
  receiptDate,
  receiptAmountAll,
  lateFreeAmount,
  receiptMethod,
}: {
  requestId: number
  receiptDate: number
  amountConvertedIntoFree: number
  receiptAmountAll: number
  lateFreeAmount: number
  receiptMethod: number
}) => {
  return http.post(contract_endpoints.addcontractdeposit, {
    requestId,
    amountConvertedIntoFree,
    receiptDate,
    receiptAmountAll,
    lateFreeAmount,
    receiptMethod,
  })
}

export const request_editcontractdeposit = async ({
  id,
  requestId,
  amountConvertedIntoFree,
  receiptDate,
  receiptAmountAll,
  lateFreeAmount,
  receiptMethod,
}: {
  id: number
  requestId: number
  receiptDate: number
  amountConvertedIntoFree: number
  receiptAmountAll: number
  lateFreeAmount: number
  receiptMethod: number
}) => {
  return http.put(contract_endpoints.editcontractdeposit, {
    id,
    requestId,
    amountConvertedIntoFree,
    receiptDate,
    receiptAmountAll,
    lateFreeAmount,
    receiptMethod,
  })
}

export const request_deletecontractdeposit = async ({Id}: {Id: Number}) => {
  return http.delete(contract_endpoints.deletecontractdeposit + '?Id=' + Id)
}

export const request_getcontractpayment = async ({RequestId}: {RequestId: Number}) => {
  return http.get(contract_endpoints.getcontractpayment + '?RequestId=' + RequestId)
}

export const request_addcontractpayment = async ({
  requestId,
  amountPaidToCompany,
  datePaidToCompany,
}: {
  requestId: number
  amountPaidToCompany: number
  datePaidToCompany: string
}) => {
  return http.post(contract_endpoints.addcontractpayment, {
    requestId,
    amountPaidToCompany,
    datePaidToCompany,
  })
}

export const request_editcontractpayment = async ({
  id,
  requestId,
  amountPaidToCompany,
  datePaidToCompany,
}: {
  id: number
  requestId: number
  amountPaidToCompany: number
  datePaidToCompany: string
}) => {
  return http.put(contract_endpoints.editcontractpayment, {
    id,
    requestId,
    amountPaidToCompany,
    datePaidToCompany,
  })
}


export const request_deletecontractpayment = async ({Id}: {Id: Number}) => {
  return http.delete(contract_endpoints.deletecontractpayment + '?Id=' + Id)
}